import React from 'react';
import { TimeFilter } from '../../types';

interface TimeFilterProps {
  active: TimeFilter;
  onChange: (filter: TimeFilter) => void;
}

const filters: { label: string; value: TimeFilter }[] = [
  { label: 'Heute', value: 'TODAY' },
  { label: 'Woche', value: 'THIS_WEEK' },
  { label: 'Monat', value: 'THIS_MONTH' },
  { label: 'Jahr', value: 'THIS_YEAR' },
];

const TimeFilterComponent: React.FC<TimeFilterProps> = ({ active, onChange }) => {
  return (
    <div className="flex p-1.5 bg-black/5 dark:bg-white/5 backdrop-blur-md rounded-2xl border border-black/5 dark:border-white/5 w-fit shadow-inner">
      {filters.map((f) => (
        <button
          key={f.value}
          onClick={() => onChange(f.value)}
          className={`
            px-5 py-2 text-sm font-medium rounded-xl transition-all duration-300
            ${active === f.value 
              ? 'bg-[#216dab] text-white shadow-lg shadow-[#216dab]/25 scale-105' 
              : 'text-slate-500 dark:text-slate-400 hover:text-[#216dab] dark:hover:text-slate-200 hover:bg-white/5'}
          `}
        >
          {f.label}
        </button>
      ))}
    </div>
  );
};

export default TimeFilterComponent;
